import { Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import { Router } from '@angular/router';
import { ServerlessOauthService, ServerlessOAuthConfig } from '@stg-js-ngx-core/oauth';
import { MmtCommonService } from '../common/services/mmt-common.service';
import { CookieService } from '../common/services/cookie.service';
import { AppConfigService } from '../appServiceConfig';

@Component({
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
  selector: 'app-oauth-callback',
  template: '<div class="text-center mt-5"><p>Authenticating...</p></div>'
})
export class OAuthCallbackComponent implements OnInit {

  constructor(
    private router: Router,
    private oauthService: ServerlessOauthService,
    private commonService: MmtCommonService,
    private cookieService: CookieService,
    private appConfigService: AppConfigService
  ) {}

  async ngOnInit(): Promise<void> {
    try {
      const config: ServerlessOAuthConfig = {
        serverless: true,
        clientId: this.appConfigService.getConfig().clientId,
        rbacEnabled: true,
        rbacAppName: this.appConfigService.getConfig().rbacAppName,
        revalidateAfterMin: 30,
        sessionExpirationAlertInMin: 3,
        longestTimeToLiveHours: 8,
        autoLogoutOnSessionExpired: true,
        logoutUrl: this.appConfigService.getConfig().baseUrls.logout,
        environmentConfig: this.appConfigService.getConfig()
      };

      const success = await this.oauthService.beginServerlessOauthHandling(config);

      if (success) {
        const profile = this.oauthService.getOauthProfile();
        if (profile?.token) {
          this.commonService.oAuthToken = profile.token;
          this.cookieService.set('host-token', profile.token, {
            expires: new Date(Date.now() + 1000 * 60 * 60 * 8),
            path: '/',
            secure: true,
            sameSite: 'Strict'
          });
        }
        this.router.navigate(['/']);
      } else {
        this.router.navigate(['/unauthorized']);
      }
    } catch (error) {
      console.error('OAuth callback failed:', error);
      this.router.navigate(['/unauthorized']);
    }
  }
}
